export const universities = [
    {
        university: 'Belarusian State University / Белорусский государственный университет',
        id: '1',
    }, {
        university: 'Belarusian National Technical University / Белорусский национальный технический университет',
        id: '2',
    }, {
        university: 'Yanka Kupala State University of Grodno / Гродненский государственный университет Янки Купалы',
        id: '3',
    }, {
        university: 'Belarusian State University of Informatics and Radioelectronics / Белорусский государственный университет информатики и радиоэлектроники',
        id: '4',
    }, {
        university: 'Gomel State University / Гомельский государственный университет Франциска Скорины',
        id: '5',
    }, {
        university: 'Belarusian State Technological University / Белорусский государственный технологический университет',
        id: '6',
    }, {
        university: 'Grodno State Medical University / Гродненский государственный медицинский университет',
        id: '7',
    }, {
        university: 'Vitebsk State Technological University / Витебский государственный технологический университет',
        id: '8',
    }, {
        university: 'Belarusian State Pedagogical University M Tank / Белорусский государственный педагогический университет М Танка',
        id: '9',
    }, {
        university: 'Vitebsk State University P M Masherov / Витебский государственный университет П М Машерова',
        id: '10',
    }, {
        university: 'Brest State Technical University / Брестский государственный технический университет',
        id: '11',
    }, {
        university: 'Polotsk State University / Полоцкий государственный университет',
        id: '12',
    }, {
        university: 'Vitebsk State Medical University / Витебский государственный медицинский университет',
        id: '13',
    }, {
        university: 'Belarusian State Medical University / Белорусский государственный медицинский университет',
        id: '14',
    }, {
        university: 'Mogilev State University A Kuleshov / Могилевский государственный университет А А Кулешова',
        id: '15',
    }, {
        university: 'Belarusian State Economic University / Белорусский государственный экономический университет',
        id: '16',
    }, {
        university: 'Polessky State University / Полесский государственный университет',
        id: '17',
    }, {
        university: 'Gomel State Medical University / Гомельский государственный медицинский университет',
        id: '18',
    }, {
        university: 'Federation of Trade Unions of Belarus International University MITSO / Федерации профсоюзов Беларуси Международный университет МИТСО',
        id: '19',
    }, {
        university: 'Minsk University of Management / Минский университет управления',
        id: '20',
    }, {
        university: 'Belarusian State University of Culture and Art / Белорусский государственный университет культуры и искусств',
        id: '21',
    }, {
        university: 'Gomel State Technical University P O Sukhoi / Гомельский государственный технический университет П О Сухого',
        id: '22',
    }, {
        university: 'Baranovichy State University / Барановичский государственный университет',
        id: '23',
    }, {
        university: 'Brest State University AS Pushkin / Брестский государственный университет А С Пушкина',
        id: '24',
    }, {
        university: 'Belarusian Medical Academy of Post Diploma Studies / Белорусская медицинская академия последипломного образования',
        id: '25',
    }, {
        university: 'Academy of Public Administration of the President of the Republic of Belarus / Академия управления при Президенте Республики Беларусь',
        id: '26',
    }, {
        university: 'Academy of Postgraduate Education / Академия последипломного образования',
        id: '27',
    }, {
        university: 'Belarusian State Agricultural Academy / Белорусская государственная сельскохозяйственная академия',
        id: '28',
    }, {
        university: 'Belarusian State University of Transport / Белорусский государственный университет транспорта',
        id: '29',
    }, {
        university: 'Grodno State Agrarian University / Гродненский государственный аграрный университет',
        id: '30',
    }, {
        university: 'Institute of Modern Languages ​A Shirokov / Институт современных знаний А М Широкова',
        id: '31',
    }, {
        university: 'Belarusian State Academy of Music / Белорусская государственная академия музыки',
        id: '32',
    }, {
        university: 'Minsk State Linguistic University / Минский государственный лингвистический университет',
        id: '33',
    }, {
        university: 'Academy of the Ministry of Internal Affairs / Академия Министерства внутренних дел Республики Беларусь',
        id: '34',
    }, {
        university: 'Belarusian State Agrarian Technical University / Белорусский государственный аграрный технический университет',
        id: '35',
    }, {
        university:
            'Mogilev Institute of the Ministry of Internal Affairs of The Republic of Belarus / Могилевский институт Министерства внутренних дел Республики Беларусь',
        id: '36',
    }, {
        university: 'Belarusian Trade and Economics University of Consumer Cooperatives / Белорусский торгово-экономический университет потребительской кооперации',
        id: '37',
    }, {
        university: 'Command-Engineering Institute MES Belarus / Командно-инженерный институт МЧС Республики Беларусь',
        id: '38',
    }, {
        university: 'Belarusian-Russian University / Белорусско-Российский университет',
        id: '39',
    }, {
        university: 'Institute for Privatization and Management / Бизнес-школа ИПМ',
        id: '40',
    }, {
        university: 'Belarusian State University of Physical Culture / Белорусский государственный университет физической культуры',
        id: '41',
    }, {
        university: 'Mozyr State Pedagogical University I P Shamyakin / Мозырский государственный педагогический университет И П Шамякина',
        id: '42',
    }, {
        university: 'Belarusian State Academy of Arts / Белорусская государственная академия искусств',
        id: '43',
    }, {
        university: 'Gomel Engineering Institute / Гомельский инженерный институт МЧС Республики Беларусь',
        id: '44',
    }, {
        university: 'Institute of Border Guard of the Republic of Belarus / Институт пограничной службы Республики Беларусь',
        id: '45',
    }, {
        university: 'Mogilev State University of Food Technologies / Могилевский государственный университет продовольствия',
        id: '46',
    }, {
        university: 'Vitebsk State Academy of Veterinary Medicine / государственная академия ветеринарной медицины',
        id: '47',
    }, {
        university: 'Institute of Parliamentarism and Entrepreneurship / Институт парламентаризма и предпринимательства',
        id: '48',
    }, {
        university: 'Minsk State Higher Radioengineering College / Минский государственный высший радиотехнический колледж',
        id: '49',
    }, {
        university: 'Private Institute of Management and Entrepreneurship / Частный институт управления и предпринимательства',
        id: '50',
    }, {
        university: 'Institute of Entrepreneurial Activity / Институт предпринимательской деятельности',
        id: '51',
    }, {
        university: 'Belarusian State Academy of Aviation / Белорусская государственная академия авиации',
        id: '52',
    }, {
        university: 'Belarusian Institute of Law / Институт правоведения',
        id: '53',
    }, {
        university: 'Military Academy of Belarus / Военная академия Республики Беларусь',
        id: '54',
    }, {
        university: 'Belarusian State Academy of Telecommunications / Белорусская государственная академия связи',
        id: '55',
    }, {
        university: 'International Humanitarian and Economic Institute / Международный гуманитарно-экономический институт',
        id: '56',
    }, {
        university:
            'Institute of Scientific Personnel Training National Academy of Sciences of Belarus / Институт подготовки научных кадров Национальной академии наук Беларуси',
        id: '57',
    },
];
